<template>
  <div id="chart" class="pt-0 pl-0">
    <apexchart
      :class="{ apexChart: isInCarousel }"
      type="bar"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import { mapState } from "vuex";
import contractYear from "@/mixins/contractYear";

export default {
  name: "SecondCarouselItem",
  mixins: [contractYear],
  props: {
    isInCarousel: {
      type: Boolean,
      default: true,
    },
    isSplited: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      stats: (state) => state.statsCustomer.statsCustomer,
    }),
    // Liste unifiée de toutes les gimCustoms
    gimCustoms() {
      // Combine les noms des deux années et élimine les doublons
      const allGimCustoms = [
        ...new Set([
          ...(this.stats.gimCustomNames || []),
          ...(this.stats.gimCustomPreviousYearNames || []),
        ]),
      ];

      // Élimine les entrées vides
      return allGimCustoms.filter((gimCustom) => gimCustom);
    },

    // Données réorganisées pour les séries
    series() {
      const currentYear = this.currentYear;
      const gimCustoms = this.gimCustoms;

      // Crée un map pour un accès rapide aux valeurs par nom
      const currentYearMap = {};
      const previousYearMap = {};

      // Remplir les maps avec les données disponibles
      if (this.stats.gimCustomNames && this.stats.gimCustomTotals) {
        this.stats.gimCustomNames.forEach((name, index) => {
          if (name) {
            currentYearMap[name] = this.stats.gimCustomTotals[index] || 0;
          }
        });
      }

      if (
        this.stats.gimCustomPreviousYearNames &&
        this.stats.gimCustomPreviousYearTotals
      ) {
        this.stats.gimCustomPreviousYearNames.forEach((name, index) => {
          if (name) {
            previousYearMap[name] =
              this.stats.gimCustomPreviousYearTotals[index] || 0;
          }
        });
      }

      // Construire les tableaux de données avec la même structure que les gimCustoms
      const currentYearData = gimCustoms.map(
        (name) => currentYearMap[name] || 0
      );
      const previousYearData = gimCustoms.map(
        (name) => previousYearMap[name] || 0
      );
      return [
        {
          name: `Chiffre d'affaires ${currentYear}`,
          data: currentYearData,
        },
        {
          name: `Chiffre d'affaires ${currentYear - 1}`,
          data: previousYearData,
        },
      ];
    },

    chartOptions() {
      return {
        chart: {
          type: "bar",
          events: {
            click: () => {
              // Gérer l'événement de clic ici
            },
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            borderRadius: 5,
            borderRadiusApplication: "end",
          },
        },
        dataLabels: {
          enabled: false,
        },
        colors: ["#FFB500", "#B2B4AE"],
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          max: undefined,
          labels: {
            rotate: -45,
            rotateAlways: true,
            style: {
              fontSize: "12px",
            },
          },
          categories: this.gimCustoms,
          tickPlacement: "on",
        },
        yaxis: {
          title: {
            text: "Chiffre d'affaires",
          },
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val.toFixed(2) + " €";
            },
          },
        },
        legend: {
          position: "bottom",
          offsetY: 0,
        },
      };
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
.apexChart {
  padding-left: 10px;
  padding-top: 25px;
}
</style>
